// Copyright ©️ 2026 eVolve MEP, LLC

import { type ComponentProps, useEffect } from 'react';

import { useEvolvePaginatedGet } from '@evolvemep/api-ts';

import { TaskGroupRow } from 'modules/Shop/Tasks/TaskTypes/TaskGroupRow';

export const UngroupedTaskGroupRow = (
  props: Pick<ComponentProps<typeof TaskGroupRow>, 'selected' | 'selectionCount' | 'onClick'>,
) => {
  const { fetchNextPage: fetchUngroupedTaskTypesCount, entireCount: ungroupedTaskTypesCount } = useEvolvePaginatedGet(
    'shop/taskType',
    // technically we don't need any data here since we're only interested in the count
    // but some endpoints don't behave correctly with perPage: 0 so want to set the precedent to at least ask for 1 item
    { perPage: 1, defaultConfig: { params: { hasNoTaskTypeGroup: true } } },
  );

  useEffect(() => {
    void fetchUngroupedTaskTypesCount();
  }, [fetchUngroupedTaskTypesCount]);

  return <TaskGroupRow label="Ungrouped Tasks" totalCount={ungroupedTaskTypesCount} {...props} />;
};
